<template>
  <button
    :class="['button', `button_${type}`, { 'button_disabled': disabled }]"
    :type="buttonNativeType"
    @click="onClick"
  >
    <slot/>
  </button>
</template>

<script>
  export default {
    name: 'BaseButton',
    props: {
      buttonNativeType: String,
      type: {
        type: String,
        default: 'main',
        validator (type) {
          return type === 'main' ||
            type === 'primary' ||
            type === 'secondary' ||
            type === 'secondary-arrow' ||
            type === 'dark'
        }
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick () {
        if (this.disabled) return
        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss">
.button {
  font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
  text-align: center;
  cursor: pointer;
  border: none;
  border-radius: 3em;
  outline: none;
  transition: 0.3s;

  &_main {
    position: relative;
    padding: 1em 1.5em;
    font-size: 16px;
    line-height: 1;
    color: $c-white;
    background-color: $c-gray-dark;
    border-radius: 0;

    &.button_disabled {
      pointer-events: none;
      user-select: none;
      outline: none;
      opacity: 1;
      background: $c-gray-4;
      color: $c-gray-dark;
    }

    &:after {
      content: '';
      left: -4px;
      top: -4px;
      position: absolute;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      opacity: 0;
      visibility: hidden;
      border: 2px solid $c-electric-blue;
      pointer-events: none;
      border-radius: 4px;
    }

    &:focus-visible {
      &:after {
        opacity: 1;
        visibility: visible;
      }
    }

    @include hover {
      background-color: $c-gray-7;
    }

    &:active {
      background: $c-extraBlack !important;
    }
  }

  &_primary {
    position: relative;
    padding: 1em 1.5em;
    font-size: 16px;
    line-height: 1;
    color: $c-white;
    background-color: $c-gray-dark;
    border-radius: 0;

    &.button_disabled {
      pointer-events: none;
      user-select: none;
      outline: none;
      opacity: 1;
      background: $c-gray-4;
      color: $c-gray-dark;
    }

    &:focus-visible {
      &:after {
        opacity: 1;
        visibility: visible;
      }
    }

    @include hover {
      background-color: $c-gray-7;
    }

    &:active {
      background: $c-extraBlack !important;
    }
  }

  &_secondary {
    padding: 0.8em 2.75em;
    font-size: 15px;
    color: $c-gray-dark;
    background-color: $c-gray-light;

    &:focus {
      background-color: $c-gray;
    }

    @include hover {
      background-color: $c-gray;
    }
  }

  &_dark {
    width: 100%;
    padding: 0.8em 2.75em;
    font-size: 15px;
    color: $c-white;
    background-color: $c-gray-dark;
  }

  &_secondary-arrow {
    position: relative;
    padding: 0.8em 57px 0.8em 30px;
    font-size: 15px;
    color: $c-gray-dark;
    background-color: $c-gray-light;

    &::before {
      position: absolute;
      top: 50%;
      right: 22px;
      margin-top: 2px;
      font-family: 'Toyota-icon-restyle', sans-serif;
      font-size: 20px;
      color: $c-active;
      content: "\e913";
      transform: translateY(-50%);
    }

    &:focus {
      background-color: $c-gray;
    }

    @include hover {
      background-color: $c-gray;
    }
  }

  &_disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
